// React Imports
import React from 'react';

// I18n
import { Translate, I18n } from 'react-redux-i18n';

// Spectrum Components
import Heading from '@react/react-spectrum/Heading';
import Button from '@react/react-spectrum/Button';


/**
 * Component for displaying the general Error Page.
 *
 * This component displays an error message and provides options to contact the helpdesk.
 *
 * @component
 * @example
 *
 * return (
 *   <ErrorGeneral />
 * )
 */
const ErrorGeneral = () => {
  // Grabs the current locale's helpdesk link and opens it in a new window.
  const onHelpdeskClick = () => {
    const url = I18n.t('global.footer.help_link');
    window.open(url, '_blank');
  };

  return (
    <div>
      <div className="page-container">
        <Heading>
          <Translate value="workflow.error_page.problem_header" />
        </Heading>
        <p>
          <Translate value="workflow.error_page.general_problem" />
        </p>
        <div className="button-container">
          <Button className="btn-helpdesk" variant="cta" onClick={onHelpdeskClick}><Translate value="workflow.error_page.contact_helpdesk" /></Button>
        </div>
      </div>
    </div>
  );
};

export default ErrorGeneral;
